import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import RoomSelect from "./RoomSelect";
import RateSelect from "./RateSelect";
import GuestSelect from "./GuestSelect";
import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import styles from "./PrettyTextList.module.css";
import DOMPurify from 'dompurify';

registerLocale("ru", ru);

function PriceExplanation(props) {
    const [promo, setPromo] = useState("");
    const [placeholderVisible, setPlaceholderVisible] = useState(true);
    const [hotelData, setHotelData] = useState({});
    const [hasError, setHasError] = useState(false);
    const [promoInfo, setPromoInfo] = useState(null);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date(moment().add(1, "days")));
    const [adultCount, setAdultCount] = useState(2);
    const [childCount, setChildCount] = useState([]);
    const [roomTypeId, setRoomTypeId] = useState(0);
    const [rateId, setRateId] = useState(0);
    const [loader, setLoader] = useState(false);
    const [showDatepicker, setShowDatepicker] = useState(false);
    const [linesData, setLinesData] = useState([]);

    useEffect(() => {
        axios.get("/api/get_ages_children").then((res) => {
            setHotelData((prevState) => ({
                ...prevState,
                ...res.data[props.hotelId],
            }));
        });
    }, []);

    let ageOptions = [
        { value: 0, label: "до 1 года" },
        { value: 1, label: "1 год" },
        { value: 2, label: "2 года" },
        { value: 3, label: "3 года" },
        { value: 4, label: "4 года" },
    ];

    for (var i = 0; i <= hotelData.child_max_age; i++) {
        if (i > 4) {
            ageOptions.push({ value: i, label: i + " лет" });
        }
    }

    function handleChildChange(id, val) {
        const arr = [...childCount];
        arr[id] = val.value;
        setChildCount(arr);
    }

    function onChildRemove(idx) {
        const arr = [...childCount];
        arr.splice(idx, 1);
        setChildCount(arr);
    }

    const endDateSafe = () => {
        if (endDate) {
            return moment(endDate).format("DD.MM.YYYY");
        }
        return "";
    };

    const renderDayContents = (day) => {
        return <div>{day}</div>;
    };

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    };

    const onDateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if (end) {
            setShowDatepicker(false);
        }
    };

    const search = () => {
        const requestData = {
            hotel_id: props.hotelId,
            adults: adultCount,
            children_info: childCount,
            date_in: moment(startDate).format("YYYY-MM-DD"),
            date_out: moment(endDate).format("YYYY-MM-DD"),
            room_type_id: roomTypeId,
            rate_id: rateId,
            promo,
        };
        setHasError(false);
        setLoader(true);

        axios
            .post("/manager/data/get_price_explanation", requestData)
            .then((response) => {
                if (Array.isArray(response.data) && response.data?.length > 0) {
                    setLinesData(response.data);
                } else {
                    setLinesData(["Никаких вариантов нет"]);
                }
            })
            .catch((e) => {
                setHasError(true);
                console.error(e);
            })
            .finally(() => setLoader(false));
    };

    const datepicker = (
        <React.Fragment>
            <DatePicker
                className="content"
                selected={startDate}
                dateFormat="dd.MM.yyyy"
                renderDayContents={renderDayContents}
                onChange={(dates) => onDateChange(dates)}
                // includeDates={availableDates}
                selectsDisabledDaysInRange
                selectsRange
                startDate={startDate}
                endDate={endDate}
                minDate={new Date()}
                locale="ru"
                monthsShown={2}
                inline
            />
        </React.Fragment>
    );

    const lines =
        linesData?.length > 0 ? (
            <div className={styles.prettyList}>
                {linesData.map((line, index) => (
                    <div
                        key={index}
                        className={styles.prettyListItem}
                        onClick={() => {
                            if (line.link !== "#") {
                                window.open(
                                    line.link,
                                    "_blank",
                                    "noopener,noreferrer",
                                );
                            }
                        }}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(line.text) }}
                    ></div>
                ))}
            </div>
        ) : null;
    const content = (
        <React.Fragment>
            <div className={"ur-container ur-mt-3 " + styles.prettyList}>
                <div className="ur-row search-form ur-pb-3">
                    <div className="search-form__wrapper">
                        <div className="search-form__input-date-in">
                            <div className="title">Заезд</div>
                            <div
                                className="content"
                                onClick={() => setShowDatepicker(true)}
                            >
                                {moment(startDate).format("DD.MM.YYYY")}
                            </div>
                        </div>
                        <div className="search-form__input-date-out">
                            <div className="title">Выезд</div>
                            <div
                                className="content"
                                onClick={() => setShowDatepicker(true)}
                            >
                                {endDateSafe()}
                            </div>
                        </div>
                        <RoomSelect
                            roomTypes={props.roomTypes}
                            roomTypeId={roomTypeId}
                            onRoomTypeIdChange={setRoomTypeId}
                        />
                        <RateSelect
                            rates={props.rates}
                            rateId={rateId}
                            onRateChange={setRateId}
                        />
                        <GuestSelect
                            onAdultChange={setAdultCount}
                            onChildChange={handleChildChange}
                            onChildRemove={(idx) => onChildRemove(idx)}
                            ageOptions={ageOptions}
                            adult={adultCount}
                            child={childCount}
                        />
                        <button
                            className="search-form__button-submit"
                            onClick={() => {
                                search();
                            }}
                            disabled={props.loading}
                        >
                            <i className="icon icon-search"></i> Найти
                        </button>
                    </div>
                </div>
                <div className="ur-row filter-form">
                    <div className="filer-promo__input-wrapper">
                        {placeholderVisible && (
                            <label className="filer-promo__placeholder">
                                Промокод
                            </label>
                        )}
                        <input
                            className="filter-form__btn filter-btn ur-mr-1 ur-mb-1 filer-promo_input"
                            onChange={({ target: { value } }) =>
                                setPromo(value)
                            }
                            onFocus={() => setPlaceholderVisible(false)}
                            onBlur={() => {
                                if (!promo) {
                                    setPlaceholderVisible(true);
                                }
                            }}
                            placeholder=""
                            type="text"
                            onKeyDown={handleKeyDown}
                        />
                        <button
                            className="search-form__button-promocode ur-mb-1"
                            onClick={() => {
                                search(false);
                            }}
                            disabled={props.loading}
                        >
                            Применить
                        </button>
                    </div>
                    {promoInfo?.promoDateFalse && (
                        <div className="search-form__error-message">
                            Извините, но по промокоду "
                            <span class="search-form__promo-name">
                                {promoInfo.name}
                            </span>
                            " на выбранные даты нет доступных предложений.
                        </div>
                    )}
                    {promoInfo?.promoActiveFalse && (
                        <div className="search-form__error-message">
                            Извините, промокод "
                            <span class="search-form__promo-name">
                                {promoInfo.name}
                            </span>
                            " уже использован. Повторное применение данного
                            промокода невозможно.
                        </div>
                    )}
                    {promoInfo?.promoExistFalse && (
                        <div className="search-form__error-message">
                            Промокод "
                            <span class="search-form__promo-name">
                                {promoInfo.name}
                            </span>
                            " не найден.
                        </div>
                    )}

                    <button
                        className="search-form__button-submit"
                        onClick={() => {
                            search(false);
                        }}
                        disabled={props.loading}
                    >
                        <i className="icon icon-search"></i> Найти
                    </button>
                </div>
            </div>

            <div
                className={`ur-modal__datepicker${showDatepicker ? " show" : ""}`}
            >
                <div className="ur-modal__datepicker-modal-dialog">
                    <div className="ur-modal__datepicker-header">
                        <div className="ur-modal__datepicker-header-head">
                            <div className="title">Даты бронирования</div>
                            <button
                                className="close"
                                onClick={() => setShowDatepicker(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="ur-modal__datepicker-header-date-inputs">
                            <div className="ur-modal__datepicker-date">
                                Заезд:&nbsp;
                                <span>
                                    {moment(props.startDate).format(
                                        "DD.MM.YYYY",
                                    )}
                                </span>
                            </div>
                            <div className="ur-modal__datepicker-date">
                                Выезд:&nbsp;<span>{endDateSafe()}</span>
                            </div>
                        </div>
                    </div>
                    <div className="ur-modal__datepicker-body">
                        {datepicker}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );

    const errorDiv = (
        <React.Fragment>
            <h2 style={{ textAlign: "center" }}>Ой, что-то пошло не так!</h2>
        </React.Fragment>
    );

    return (
        <React.Fragment>
            {
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    {content}
                    {hasError ? errorDiv : loader ? load : lines}
                </div>
            }
        </React.Fragment>
    );
}

export default PriceExplanation;

const load = (
    <div className="ur-text-center">
        <div className="progress-circle" />
    </div>
);
